import * as React from 'react';
import Box from '@material-ui/core/Box';

const CustomBox = (props) => {
    return <Box {...props} />;
};

export { CustomBox as Box };
